<template>
  <v-container>
    <v-row class="headline">Add to the story...</v-row>

    <v-form ref="editform" v-model="formvalid" lazy-validation >
      <v-container>
        <quill-editor
            ref="myQuillEditor"
            v-model="content"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @ready="onEditorReady($event)"
          >
          </quill-editor>
          <v-row v-if="editorError" class="red--text ml-1">{{editorError}} </v-row>
        </v-container>
      <v-row class="headline">
        What happens next?
      </v-row>
      <v-row class="ml-2">
        <v-radio-group row v-model="radioValue">
            <v-radio value="continue" label="Continue from here without options"></v-radio>
            <v-radio value="options" label="Add options for the reader to choose"></v-radio>
        </v-radio-group>
      </v-row>
      <div v-if="radioValue=='options'" class="ml-2">
        <v-row></v-row>
        <v-text-field
            v-model="opt1"
            :rules="requiredOptionRules"
            outlined
            clearable
            required
            label="Option 1 (required)"
            type="text"
            hint="At least two options are required."
            id="opt1"
          ></v-text-field>
          <v-text-field
              v-model="opt2"
              :rules="requiredOptionRules"
              outlined
              clearable
              required
              label="Option 2 (required)"
              type="text"
              hint="At least two options are required."
              id="opt2"
            ></v-text-field>
            <v-text-field
                v-model="opt3"
                :rules="optionRules"
                outlined
                clearable
                label="Option 3 (optional)"
                type="text"
                id="opt3"
              ></v-text-field>
              <v-text-field
                  v-model="opt4"
                  :rules="optionRules"
                  outlined
                  clearable
                  label="Option 4 (optional)"
                  type="text"
                  id="opt4"
                ></v-text-field>
      </div>

      <v-row class="headline">
        Be the author!
      </v-row>
      <v-row class="ml-2">
        <v-text-field
            v-model="firstname"
            :rules="firstnameRules"
            outlined
            clearable
            label="Your first name (optional)"
            type="text"
            hint="This will be shown as the author of this page."
            id="firstname"
          ></v-text-field>
          <v-spacer></v-spacer>

          <div v-if="$route.params.storyID==sampleStoryID">
            <v-btn text color="light-blue" @click="sampleStoryAlert">
              Add the page<v-icon size="50" >{{ mdiArrowRightCircleOutline }}</v-icon>
            </v-btn>
          </div>
          <vue-recaptcha
              ref="invisibleRecaptcha"
              size="invisible"
              :sitekey="sitekey"
              @verify="onVerify"
              @expired="onExpired"
              v-else
              >
              <v-btn text color="light-blue" :disabled="!formvalid" :loading="loading">
                Add the page<v-icon size="50" >{{ mdiArrowRightCircleOutline }}</v-icon>
              </v-btn>
          </vue-recaptcha>

      </v-row>
      <v-row v-if="!formvalid">
        <v-spacer></v-spacer>
        <span class="red--text">Fix form errors before submission.</span>
      </v-row>
    </v-form>
    <v-row v-if="errtext" class="red--text">
      {{errtext}}
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>
        <v-card-text>Once you add the page you can no longer change it.</v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="addPage">Add Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import config from '../config.js'
import { mdiArrowRightCircleOutline } from '@mdi/js'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'EditView',
  // props: ['title', 'text', 'options'],
  components: {
    quillEditor, VueRecaptcha
  },
  data: () => ({
    sampleStoryID: 'eOpxGFkETLBg8ed7QXQH',
    sitekey: config.recaptchaSiteKey,
    mdiArrowRightCircleOutline: mdiArrowRightCircleOutline,
    loading: false,
    errtext: null,
    dialog: false,
    editorError: '',
    content: '',
    radioValue: 'continue',
    opt1: '',
    opt2: '',
    opt3: '',
    opt4: '',
    formvalid: false,
    editorOption: {
      // Some Quill options...
      placeholder: 'Write your page here...',
      formats: ['background', 'bold', 'color', 'font', 'italic', 'size', 'underline', 'blockquote', 'header', 'indent',
        'list', 'align'],
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          // ['blockquote'],
          [{ header: 1 }, { header: 2 }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          // [{ indent: '-1' }, { indent: '+1' }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          // [{ font: [] }],
          [{ color: [] }, { background: [] }]
          // [{ align: [] }],
          // ['clean']
          // ['link', 'image', 'video']
        ]
      }
    },
    firstname: '',
    firstnameRules: [
      v => !v || v.length <= 40 || 'Name must be less than 40 characters',
      v => !v || /^[\w\-\s]+$/.test(v) || 'Name cannot contain special characters'
    ],
    optionRules: [
      v => !v || v.length <= 250 || 'Option cannot be more than 250 characters',
      v => !v || /^[\w\-\s.?!,;'"$]+$/.test(v) || 'Option cannot contain special characters'
    ],
    editorRules: [
      v => !!v || 'You have to write something!',
      v => !!v || (v || '').length <= 10000 || 'Text cannot be more than 10,000 characters'
    ]

  }),
  mounted () {
    const fn = this.$cookies.get('firstname')
    if (fn) {
      this.firstname = fn
    }
  },
  methods: {
    sampleStoryAlert () {
      alert('Sample story cannot be editted but you get the idea.')
    },

    onEditorBlur (quill) {
      // console.log('editor blur!', quill)
      this.validateEditor()
    },
    onEditorFocus (quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      // console.log('editor ready!', quill)
    },
    onEditorChange ({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    },
    addPage (recaptchaToken) {
      this.loading = true
      this.dialog = false
      // Validate the form
      this.formvalid = this.$refs.editform.validate()

      if (this.formvalid) {
        // Send the page info to the server
        this.errtext = null
        const dynFunction = config.getFunctions().httpsCallable('dynFunction')

        const storyID = this.$route.params.storyID
        const pageID = this.$route.params.pageID
        const storyPasswords = this.$cookies.get('storyPasswords')
        const lockID = this.$cookies.get('lockID')

        if (this.firstname) {
          // Save it!
          this.$cookies.set('firstname', this.firstname, '5y')
        }

        dynFunction({
          call: 'addPage',
          storyID: storyID,
          pageID: pageID,
          storyPasswords: storyPasswords,
          lockID: lockID,
          firstname: this.firstname,
          content: this.content,
          radioValue: this.radioValue,
          opt1: this.opt1,
          opt2: this.opt2,
          opt3: this.opt3,
          opt4: this.opt4,
          recaptchaToken: recaptchaToken

        }).then((rc) => {
          // The page was added!
          /// read/:storyID/:pageID
          // const addedPageID = rc.data.addedPageID
          // this.$router.push({ path: '/read/' + storyID + '/' + addedPageID })
          this.$emit('setPageReady')
          this.loading = false

          if (this.$gtag) {
            this.$gtag.event('addPage', { method: 'Natural' })
          }
        }).catch((err) => {
          console.error('Error addPage: ' + err)
          this.errtext = err
          this.loading = false
          this.resetRecaptcha()
        })
      }
    },
    onVerify: function (response) {
      // Recaptcha Verify
      // console.log('Verify: ' + response)

      // Call to the server to verify and respond.
      this.addPage(response)
    },
    onExpired: function () {
      // Recaptcha expired
      console.log('Expired')
    },
    resetRecaptcha () {
      this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    },
    showConfirm () {
      // Validate the form
      this.formvalid = this.$refs.editform.validate()
      if (this.formvalid) {
        this.validateEditor()
      }

      if (this.formvalid) {
        this.dialog = true
      }
    },
    validateEditor () {
      // Validate the content in the quill editor
      if (!this.content) {
        this.formvalid = false
        this.editorError = 'You must write something'
      } else if (this.content.length > 10000) {
        this.formvalid = false
        this.editorError = 'Page cannot be more than 10,000 characters!'
      } else {
        this.editorError = ''
        this.formvalid = this.$refs.editform.validate()
      }
    }

  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    },
    requiredOptionRules () {
      return [
        v => !!v || 'This option is required'
      ].concat(this.optionRules)
    }

  }
}
</script>
